import { inject, Injectable, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { CandidateSearchStore } from './candidate-search.store';
import { LocumsMarginCalculatorEvents } from 'src/app/recruiting/locums-margin-calculator/store/enums/locums-margin-calculator-events.enum';
import { CandidateSearch } from 'src/app/recruiting/locums-margin-calculator/models/candidate-search.model';
import { RecipientSearch } from '../../models/recipient-search.model';

@Injectable({ providedIn: 'root' })
export class CandidateSearchReducer {
    private readonly candidateSearchStore = inject(CandidateSearchStore);
    private readonly eventBus = inject(EventBusService);
    private readonly destroy$ = inject(DestroyRef);

    constructor() {
        this.listenToSearchEvent();
        this.listenToRecipientSearchEvent();
    }

    private listenToSearchEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.CANDIDATE_SELECTED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.candidateSearchStore.setSelectedCandidate(event.payload.candidate as CandidateSearch);
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.CANDIDATE_SELECTED_RESET)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe(() => {
                this.candidateSearchStore.clearSelectedCandidate();
                this.candidateSearchStore.setCandidates([]);
                this.candidateSearchStore.setMarginId(null);
            });
    }

    private listenToRecipientSearchEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.REFERRAL_BONUS_RECIPIENT_SEARCHED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.candidateSearchStore.setRecipients(event.payload as RecipientSearch[]);
            });
    }
}
